import { DeviceDetailInfoGridProps } from "./DeviceDetailInfoGrid";
import DeviceDetailInfoGridForFS050W from "./DeviceDetailInfoGridForFS050W";

const DeviceDetailInfoGridForFS045W: React.FC<DeviceDetailInfoGridProps> = ({
  contentColor = "#16191f",
  contentFontSize = "0.875rem",
  device,
}) => {
  // FS050Wと同じレイアウトを使用(FS045W用にCellInfo表示を追加)
  return (
    <DeviceDetailInfoGridForFS050W
      contentColor={contentColor}
      contentFontSize={contentFontSize}
      device={device}
      fs045WInfo={true}
    />
  );
};

export default DeviceDetailInfoGridForFS045W;